import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackCTA } from '../utils/analytics';

const CTASection = ({ t }) => {
  const navigate = useNavigate();

  const handleScheduleConsultation = () => {
    trackCTA('Schedule Consultation', 'CTA Section');
    navigate('/contact');
  };

  return (
    <section className="relative py-20 px-4 md:px-0 bg-[#181c24] text-white text-center overflow-hidden">
      <div className="relative z-10 max-w-3xl mx-auto flex flex-col items-center justify-center">
        <h2 className="text-3xl md:text-4xl font-playfair mb-4 text-[#f7e6df]">{t.cta.readyToBegin}</h2>
        <button
          onClick={handleScheduleConsultation}
          className="border border-[#bfa76a] text-[#bfa76a] bg-transparent py-4 px-10 rounded-full text-lg font-semibold shadow-sm hover:bg-[#bfa76a] hover:text-[#181c24] transition-all duration-300 mb-4 text-center justify-center"
        >
          {t.cta.scheduleConsultation}
        </button>
        <p className="text-base text-[#f7e6df]/80 max-w-xs whitespace-pre-line">
          {t.cta.consultationDetails}
        </p>
      </div>
    </section>
  );
};

export default CTASection; 